import { useDispatch, useSelector } from "react-redux"
import TagBox from "./TagBox";

// conveyor, project, structure, tower 각각 있어야 하는 이유인가?? 
import { changeField } from "../../modules/project/projectWriteSlice";

const TagBoxContainer = () => {
    const dispatch = useDispatch();
    // const { tags } = useSelector(({ projectWrite }) => ({
    //     tags: projectWrite.tags,
    // }));

    const tags = useSelector(state => state.projectWrite.tags);

    const onChangeTags = nextTags => {
        dispatch(
            changeField({
                key: 'tags',
                value: nextTags,
            })
        );
    };

    return (
        <TagBox onChangeTags={onChangeTags} tags={tags} />
    );
};

export default TagBoxContainer;